import React from "react";

const Footer = () => {
  const site = window.site;
  const social = JSON.parse(site.social);
  const name=site.name;
  const url=site.site_url;

  const hasSocialLinks = Object.values(social).some((url) => url);

  return (
    <div class="appFooter">
      <a href="/" target="_blank">
        <img
          src={`${url}/assets/img/svg/logo.text.svg`}
          alt="icon"
          class="footer-logo mb-2"
        />
      </a>

      <div class="footer-title">
        Copyright ©{" "}
        <a href={url} target="_blank">
           {name}
        </a>{" "}
        <span class="yearNow"></span>. All Rights Reserved.
      </div>
      <div class="mb-1">
        {name} Reward App is{" "}
        <i class="bi bi-lightning-fill text-warning" title="Powered"></i> by{" "}
        <a href="//taskwall.ai/" target="_blank">
          TaskWall
        </a>
        .
      </div>
      <a href="//taskwall.ai/" target="_blank">
        Partner with Us
      </a>

      {hasSocialLinks && (
        <div class="mt-2">
          {social.facebook && (
            <a href={social.facebook } class="btn btn-icon btn-sm btn-facebook">
              <ion-icon name="logo-facebook"></ion-icon>
            </a>
          )}
          {social.twitter && (
            <a href={social.twitter } class="btn btn-icon btn-sm btn-twitter">
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
          )}

          {social.linkedin && (
            <a href={social.linkedin } class="btn btn-icon btn-sm btn-linkedin">
              <ion-icon name="logo-linkedin"></ion-icon>
            </a>
          )}

          {social.instagram && (
            <a href={social.instagram} class="btn btn-icon btn-sm btn-instagram">
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
          )}

          {social.whatsapp && (
            <a href={social.whatsapp} class="btn btn-icon btn-sm btn-whatsapp">
              <ion-icon name="logo-whatsapp"></ion-icon>
            </a>
          )}

          <a href="#" class="btn btn-icon btn-sm btn-secondary goTop">
            <ion-icon name="arrow-up-outline"></ion-icon>
          </a>
        </div>
      )}
    </div>
  );
};

export default Footer;
